import toast from "react-hot-toast";
import { studentBuyCourseEndpoints } from "../apis";
import { apiConnector } from "../apiconnector";
import logo from '../../assets/Logo/StudyNexaaLogo.png'
import { setPaymentLoading } from "../../redux/slices/courseSlice";
import { resetWishlist } from "../../redux/slices/wishlistSlice";
import { userDetail } from "./profileApi";
import { setUser } from "../../redux/slices/profileSlice";
import { setBlurLoading } from "../../redux/slices/authSlice";

const {
    COURSE_PAYMENT_API,
    COURSE_VERIFY_API,
    SEND_PAYMENT_SUCCESS_EMAIL_API,
} = studentBuyCourseEndpoints;
const loadScript = (src) => {
    return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => {
            resolve(true);
        };
        script.onerror = () => {
            resolve(false);
        };
        document.body.appendChild(script);
    });
};
async function sendPaymentSuccessEmail(response, amount) {
    try {
        await apiConnector("POST", SEND_PAYMENT_SUCCESS_EMAIL_API, {
            orderId: response.razorpay_order_id,
            paymentId: response.razorpay_payment_id,
            amount,
        });
    } catch (error) {
        console.error("PAYMENT SUCCESS EMAIL API ERROR - ", error.message);
    }
}
async function verifyPayment(bodyData, navigate, dispatch) {
    const toastId = toast.loading('Verifying Payment...');
    dispatch(setBlurLoading(true));
    dispatch(setPaymentLoading(true));
    try {
        const response = await apiConnector("POST", COURSE_VERIFY_API, bodyData);

        if (!response.data.success) {
            throw new Error(response.data.message);
        }
        toast.success("Payment Successful. Welcome to your new course!");

        try {
            const userDetailsResponse = await userDetail();

            if (!userDetailsResponse.data.success) {
                return toast.error(userDetailsResponse.data.message);
            }
            dispatch(setUser(userDetailsResponse.data.user));
            localStorage.setItem('user', JSON.stringify(userDetailsResponse.data.user));
        } catch (error) {
            console.error('Fetching User Detail failed => ', error);
            toast.error('Live reload failed, please log in again');
        }
        navigate("/dashboard/enrolled-courses");
        dispatch(resetWishlist());
    } catch (error) {
        console.error('Payment verification API error - ', error.message);
        toast.error("Payment verification failed");
    } finally {
        toast.dismiss(toastId);
        dispatch(setPaymentLoading(false));
        dispatch(setBlurLoading(false));
    }
}

export const buyCourse = async (courses, user, navigate, dispatch) => {
    dispatch(setBlurLoading(true));
    dispatch(setPaymentLoading(true));
    try {
        const scriptLoaded = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
        if (!scriptLoaded) {
            return toast.error("Razorpay SDK failed to load");
        }
        const orderResponse = await apiConnector("POST", COURSE_PAYMENT_API, { courses });
        if (!orderResponse.data.success) {
            throw new Error(orderResponse.data.message);
        }
        const options = {
            key: 'rzp_test_jSIA0WMLQCcQDt',
            currency: orderResponse.data.data.currency,
            amount: orderResponse.data.data.amount.toString(),
            order_id: orderResponse.data.data.id,
            name: "StudyNexaa",
            description: "Thank you for purchasing the course",
            image: { logo },
            prefill: {
                name: `${user.firstName}`,
                email: `${user.email}`,
            },
            theme: {
                color: "#000814",
            },
            handler: async function (response) {
                sendPaymentSuccessEmail(response, orderResponse.data.data.amount);
                verifyPayment({ ...response, courses }, navigate, dispatch);
            }
        };
        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
        paymentObject.on("payment.failed", function (response) {
            toast.error('Oops, payment failed');
            console.error(response.error);
        });
    } catch (error) {
        console.error('PAYMENT API ERROR - ', error.message);
        toast.error("Payment failed in buyCourseApi");
    } finally {
        dispatch(setPaymentLoading(false));
        dispatch(setBlurLoading(false));
    }
};